import router from './router';
import Vue from 'vue';
import Vuex from 'vuex';
// npgrogress    g2  axios  vue-cookies
// 		 wsrProxy

import ElementUI from 'element-ui';
import '@@/assets/css/element-variables.scss';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from 'element-ui/lib/locale/lang/en';
import viLocale from 'element-ui/lib/locale/lang/vi';
import deLocale from 'element-ui/lib/locale/lang/de';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';

import VueUploadComponent from 'vue-upload-component';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import VueI18n from 'vue-i18n';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import device from 'current-device';
import qs from 'qs';
import filterXSS from 'xss';
import 'swiper/css/swiper.css';
import VueCookies from 'vue-cookies';

import '@@/assets/css/icon/iconfont.css';
import global_css from '@@/assets/css/global.scss';
import '@@/assets/css/font.css';
import '@@/assets/js/apis.js';
import zh_CNBk from '@@/assets/js/zh_CNBk.js';
import timeFormat from '@/common/filters/timeFormat.js';
import numberFormat from '@/common/filters/numberFormat.js';
import ifNullFormat from '@/common/filters/ifNullFormat.js';
import dictFormat from '@/common/filters/dictFormat.js';
import mapFormat from '@/common/filters/mapFormat.js';
import pFormat from '@/common/filters/pFormat.js';
import buttonAuthority from '@/common/filters/buttonAuthority.js';
import buryLog from '@/common/directives/buryLog.js';
import bury from '@/common/bury.js';
import dialogDrag from '@/common/directives/dialogDrag.js';

// Vue.config.devtools = true
import store from '@@/assets/js/store.js';
import utils from '@/common/utils';
import http from '@/common/http';
import app from '@@/pages/app/app';
import yi_curd_data from '@/common/curd/yi_curd_data';
import yi_bury_data from '@/common/yi_bury/yi_bury_data';

const Base64 = require('js-base64').Base64;

import * as math from 'mathjs';
import * as echarts from 'echarts';

import { Graph as x6 } from '@antv/x6';
import '@antv/x6-vue-shape';
import node1 from '@@/components/craft/node1.vue';
import node2 from '@@/components/craft/node2.vue';
import node3 from '@@/components/craft/node3.vue';
import node4 from '@@/components/craft/node4.vue';
import node5 from '@@/components/craft/node5.vue';
import { DagreLayout as x6layout } from '@antv/layout';

Vue.component('file-upload', VueUploadComponent);
Vue.use(VueAwesomeSwiper);
dayjs.extend(dayjsPluginUTC);
Vue.use(VueI18n);
Vue.use(VueCookies);

dayjs.extend(isBetween);

Vue.prototype.dayjs = dayjs;
Vue.prototype.qs = qs;
Vue.prototype.device = device;
Vue.prototype.filterXSS = filterXSS;
Vue.prototype.global_css = global_css;
Vue.prototype.global = {};
Vue.prototype.store = store;
Vue.prototype.buttonAuthority = buttonAuthority;
Vue.prototype.math = math;
Vue.prototype.echarts = echarts;
Vue.prototype.x6 = x6;
Vue.prototype.x6layout = x6layout;
Vue.prototype.base64 = Base64;
Vue.prototype.bury = bury;

Vue.use(utils);
Vue.use(http);
Vue.use(VueI18n);

//注册过滤器
Vue.filter('time', timeFormat);
Vue.filter('number', numberFormat);
Vue.filter('ifNull', ifNullFormat);
Vue.filter('dict', dictFormat);
Vue.filter('map', mapFormat);
Vue.filter('pformat', pFormat);
Vue.filter('button', buttonAuthority);
Vue.directive('burylog', buryLog);
Vue.directive('dialogDrag', dialogDrag);
if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', 'zh_CN');
}
const i18n = new VueI18n({
  locale: localStorage.getItem('lang'),
  fallbackLocale: 'zh_CN',
  silentFallbackWarn: true, // 没有当前语言,回退到默认语言的警告
  silentTranslationWarn: true // 没有翻译,显示key的警告
});
i18n.setLocaleMessage('zh_CN', zh_CNBk);
// 根据当前语言选择ElementUI的语言包
const getElementUILocale = lang => {
  switch (lang) {
    case 'en_US':
      return enLocale;
    case 'zh_CN':
      return zhLocale;
    case 'vi_VN':
      return viLocale;
    case 'de_DE':
      return deLocale;
    case 'ru_RU':
      return ruLocale;
    default:
      return zhLocale;
  }
};

const currentLang = localStorage.getItem('lang') || 'zh_CN';
Vue.use(ElementUI, {
  locale: getElementUILocale(currentLang)
});
ElementUI.Dialog.props.lockScroll.default = false;

// Vue.prototype.http.get(`/system/i18n/zh_CN.json?_allow_anonymous=false`, {
// 	isRes: true,
// }).then(res => {
// 	i18n.setLocaleMessage('zh_CN', res);
// 	i18n.locale = 'zh_CN'
// }).catch((err) => {
// 	console.log(err)
// })
Vue.prototype.i18n = i18n;

Vue.config.productionTip = false;
window.addEventListener(
  'popstate',
  function(e) {
    router.isBack = true;
  },
  false
);

Vue.mixin(yi_curd_data);
Vue.mixin(yi_bury_data);

import circle_progress from '@/common/circle_progress/circle_progress';
Vue.component('circle_progress', circle_progress);

import yi_button from '@/common/yi_button/yi_button';
Vue.component('yi_button', yi_button);

import circle_progress_360 from '@/common/circle_progress/circle_progress_360';
Vue.component('circle_progress_360', circle_progress_360);

import dynamic_nav from '@/common/dynamic_nav/dynamic_nav';
Vue.component('dynamic_nav', dynamic_nav);

import yi_print_template from '@/common/yi_print_template/yi_print_template';
Vue.component('yi_print_template', yi_print_template);

import yi_print_preview from '@/common/yi_print_template/yi_print_preview';
Vue.component('yi_print_preview', yi_print_preview);

import yi_curd_table from '@/common/curd/yi_curd_table';
Vue.component('yi_curd_table', yi_curd_table);

import yi_time_input from '@/common/yi_time_input/yi_time_input';
Vue.component('yi_time_input', yi_time_input);

import yi_dictionary_select from '@/common/yi_dictionary_select/yi_dictionary_select';
Vue.component('yi_dictionary_select', yi_dictionary_select);

import yi_data_select from '@/common/yi_data_select/yi_data_select';
Vue.component('yi_data_select', yi_data_select);

import yi_cross_select from '@/common/yi_cross_select/yi_cross_select';
Vue.component('yi_cross_select', yi_cross_select);

import yi_curd_expand_button from '@/common/curd/yi_curd_expand_button';
Vue.component('yi_curd_expand_button', yi_curd_expand_button);

import yi_cascader from '@/common/yi_cascader/yi_cascader';
Vue.component('yi_cascader', yi_cascader);

import yi_number_input from '@/common/yi_number_input/yi_number_input';
Vue.component('yi_number_input', yi_number_input);

import yi_upload from '@/common/yi_upload/yi_upload';
Vue.component('yi_upload', yi_upload);

import yi_excel_import from '@/common/yi_excel_import/yi_excel_import';
Vue.component('yi_excel_import', yi_excel_import);

import auto_scroll from '@/common/auto_scroll/auto_scroll';
Vue.component('auto_scroll', auto_scroll);

import web_base_matter_list from '@@/pages/web/base/matter/list';
Vue.component('web_base_matter_list', web_base_matter_list);

import web_base_equipment_list from '@@/pages/web/base/equipment/list';
Vue.component('web_base_equipment_list', web_base_equipment_list);

import web_process_management_analysis_index from '@@/pages/web/process_management/analysis/index';
Vue.component('web_process_management_analysis_index', web_process_management_analysis_index);

import web_base_stop_reason_list from '@@/pages/web/base/stop_reason/list';
Vue.component('web_base_stop_reason_list', web_base_stop_reason_list);

import admin_equipment_series_list from '@@/pages/admin/equipment/series/list';
Vue.component('admin_equipment_series_list', admin_equipment_series_list);

import admin_equipment_series_series_model from '@@/pages/admin/equipment/series/series_model';
Vue.component('admin_equipment_series_series_model', admin_equipment_series_series_model);

import web_base_equipment_equipment_standing from '@@/pages/web/base/equipment/equipment_standing';
Vue.component('web_base_equipment_equipment_standing', web_base_equipment_equipment_standing);

import web_process_management_analysis_analyze_table from '@@/pages/web/process_management/analysis/analyze_table';
Vue.component('web_process_management_analysis_analyze_table', web_process_management_analysis_analyze_table);

import web_system_export_list from '@@/pages/web/system/export/list';
Vue.component('web_system_export_list', web_system_export_list);

import web_base_mould_list from '@@/pages/web/base/mould/list';
Vue.component('web_base_mould_list', web_base_mould_list);

import admin_global_role_list from '@@/pages/admin/global/role/list';
Vue.component('admin_global_role_list', admin_global_role_list);

import admin_customer_info_list from '@@/pages/admin/customer/info/list';
Vue.component('admin_customer_info_list', admin_customer_info_list);

import web_system_role_list from '@@/pages/web/system/role/list';
Vue.component('web_system_role_list', web_system_role_list);

import admin_data_template_protocol_list from '@@/pages/admin/data_template/protocol/list';
Vue.component('admin_data_template_protocol_list', admin_data_template_protocol_list);

import admin_iotdm_card_list from '@@/pages/admin/iotdm/card/list';
Vue.component('admin_iotdm_card_list', admin_iotdm_card_list);

import admin_iotdm_gateway_list from '@@/pages/admin/iotdm/gateway/list';
Vue.component('admin_iotdm_gateway_list', admin_iotdm_gateway_list);

import admin_iotdm_protocol_list from '@@/pages/admin/iotdm/protocol/list';
Vue.component('admin_iotdm_protocol_list', admin_iotdm_protocol_list);

import web_andon_management_reporting_level_list from '@@/pages/web/andon_management/reporting_level/list';
Vue.component('web_andon_management_reporting_level_list', web_andon_management_reporting_level_list);

import web_system_user_list from '@@/pages/web/system/user/list';
Vue.component('web_system_user_list', web_system_user_list);

import web_order_management_production_plan_equipment_list from '@@/pages/web/order_management/production_plan/equipment/list';
Vue.component('web_order_management_production_plan_equipment_list', web_order_management_production_plan_equipment_list);

import web_order_management_production_plan_mold_list from '@@/pages/web/order_management/production_plan/mold/list';
Vue.component('web_order_management_production_plan_mold_list', web_order_management_production_plan_mold_list);

import web_quality_management_work_order from '@@/pages/web/quality_management/work_order';
Vue.component('web_quality_management_work_order', web_quality_management_work_order);

import web_quality_management_sampling_procedure_list from '@@/pages/web/quality_management/sampling_procedure/list';
Vue.component('web_quality_management_sampling_procedure_list', web_quality_management_sampling_procedure_list);

import web_wms_purchase_receipt_supplier_information from '@@/pages/web/wms/purchase_receipt/supplier_information';
Vue.component('web_wms_purchase_receipt_supplier_information', web_wms_purchase_receipt_supplier_information);

import web_wms_purchase_receipt_check_warehouse_code from '@@/pages/web/wms/purchase_receipt/check/warehouse_code';
Vue.component('web_wms_purchase_receipt_check_warehouse_code', web_wms_purchase_receipt_check_warehouse_code);

import web_wms_purchase_receipt_check_warehouse_area_code from '@@/pages/web/wms/purchase_receipt/check/warehouse_area_code';
Vue.component('web_wms_purchase_receipt_check_warehouse_area_code', web_wms_purchase_receipt_check_warehouse_area_code);
import web_wms_purchase_receipt_check_warehouse_location_code from '@@/pages/web/wms/purchase_receipt/check/warehouse_location_code';
Vue.component('web_wms_purchase_receipt_check_warehouse_location_code', web_wms_purchase_receipt_check_warehouse_location_code);

import web_wms_delivery_issue_customer_information from '@@/pages/web/wms/delivery_issue/customer_information';
Vue.component('web_wms_delivery_issue_customer_information', web_wms_delivery_issue_customer_information);
import web_wms_delivery_issue_check_select_inventory from '@@/pages/web/wms/delivery_issue/check/select_inventory';
Vue.component('web_wms_delivery_issue_check_select_inventory', web_wms_delivery_issue_check_select_inventory);

import admin_data_equipment_template_point from '@@/pages/admin/data_template/protocol/template_point';
Vue.component('admin_data_equipment_template_point', admin_data_equipment_template_point);

import web_production_management_work_order_execution_equipment_list from '@@/pages/web/production_management/work_order_execution/equipment/list';
Vue.component('web_production_management_work_order_execution_equipment_list', web_production_management_work_order_execution_equipment_list);

import web_base_print_list from '@@/pages/web/base/print/list';
Vue.component('web_base_print_list', web_base_print_list);

import web_scheduling_production_plan_list from '@@/pages/web/scheduling/production_plan/list';
Vue.component('web_scheduling_production_plan_list', web_scheduling_production_plan_list);

import web_supplier_portal_purchase_order_accept_list from '@@/pages/web/supplier_portal/purchase_order_accept/list';
Vue.component('web_supplier_portal_purchase_order_accept_list', web_supplier_portal_purchase_order_accept_list);

import web_mixture_order_work_order from '@@/pages/web/material_management/mixture_order/work_order/work_order';
Vue.component('web_mixture_order_work_order_component', web_mixture_order_work_order);

import web_purchasing_management_purchase_requisition_list from '@@/pages/web/purchasing_management/purchase_requisition/list';
Vue.component('web_purchasing_management_purchase_requisition_list', web_purchasing_management_purchase_requisition_list);

import web_employment_management_employee_component from '@@/pages/web/employment_management/employee';
Vue.component('web_employment_management_employee_component', web_employment_management_employee_component);

import admin_user_info_list from '@@/pages/admin/user/info/list';
Vue.component('admin_user_info_list', admin_user_info_list);

import yi_tabs from '@/common/yi_tabs/yi_tabs';
Vue.component('yi_tabs', yi_tabs);

// 尝试下在菜单之后再异步引入
/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: `<app></app>`,
  router,
  store,
  i18n,
  components: {
    app
  },
  computed: {
    ...Vuex.mapState(['equipmentsMap']),
    eqs() {
      return Object.values(this.equipmentsMap).sort((eq1, eq2) => {
        return eq1.priority - eq2.priority;
      });
    }
  },
  data() {
    return {
      lastDicTime: new Date().getTime()
    };
  },
  created() {
    //在这里设置一下图标
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = require('@@/assets/img/base/favicon.png');
    document.getElementsByTagName('head')[0].appendChild(link);

    //这种是全局监听方法，假如我在请求处遇到403，那么我就发送403通知，在这里进行处理。为何要提取出来处理，那是因为不同应用对登陆有不同操作。
    //如网站，可以弹框也可以跳到登录页。如app，就是弹出登录页
    this.utils.event_hub.$on('NEED_LOGIN', this.toLogin);

    sessionStorage.setItem('platform', 'web');

    this.registerFlowNode();
    this.startTicker();
    this.getBaseData();
    this.setEnterKey();
    this.refreshDictionay();
  },
  methods: {
    ...Vuex.mapActions(['refreshEqData']),
    registerFlowNode() {
      // 方式2：注册 vue component
      this.x6.registerNode('node1', {
        inherit: 'vue-shape',
        x: 200,
        y: 150,
        width: 150,
        height: 100,
        component: {
          template: `<node1 />`,
          components: {
            node1
          }
        }
      });
      this.x6.registerNode('node2', {
        inherit: 'vue-shape',
        x: 200,
        y: 150,
        width: 150,
        height: 100,
        component: {
          template: `<node2 />`,
          components: {
            node2
          }
        }
      });
      this.x6.registerNode('node3', {
        inherit: 'vue-shape',
        x: 200,
        y: 150,
        width: 150,
        height: 100,
        component: {
          template: `<node3 />`,
          components: {
            node3
          }
        }
      });
      this.x6.registerNode('node4', {
        inherit: 'vue-shape',
        x: 200,
        y: 150,
        width: 150,
        height: 100,
        component: {
          template: `<node4 />`,
          components: {
            node4
          }
        }
      });
      this.x6.registerNode('node5', {
        inherit: 'vue-shape',
        x: 200,
        y: 150,
        width: 150,
        height: 100,
        component: {
          template: `<node5 />`,
          components: {
            node5
          }
        }
      });
    },
    setEnterKey() {
      window.addEventListener('keydown', () => {
        if (event.keyCode === 13) {
          //如当前是存在弹框则不生效，因为弹框内嵌套太多层搜索按钮，并且弹框内输入textarea的时候的回车也会影响到。
          let dialogs = document.getElementsByClassName('el-dialog__wrapper');
          for (let dialog of dialogs) {
            var style = window.getComputedStyle(dialog); //el即DOM元素
            if (style.display != 'none') {
              console.log('弹框里面');
              return;
            }
          }
          let sousuos = [];
          let buttons = document.getElementsByTagName('button');
          for (let btn of buttons) {
            let spans = btn.getElementsByTagName('span');
            if (spans.length == 0) {
              continue;
            }
            if (spans[0].innerText == '搜索' || spans[0].innerText == 'search') {
              sousuos.push(btn);
            }
          }
          if (sousuos.length > 0) {
            sousuos[sousuos.length - 1].click();
          }
        }
      });
    },
    startTicker() {
      setInterval(() => {
        this.store.commit('SET_CURRENT_TIME', this.dayjs().format('YYYY-MM-DD HH:mm:ss'));
      }, 1000);
    },
    refreshDictionay() {
      //获取字典
      setInterval(() => {
        if (!this.utils.isUserLogin()) {
          return;
        }
        this.http.get('web/config/customer/dictionary/item/getDictionaryLatestModificationTime').then(res => {
          if (res.data > this.lastDicTime) {
            //获取字典
            this.http.get('web/config/dictItem/getDictJson?deleted=false').then(res => {
              this.store.commit('SET_DICTJSON', res.data);
            });
            //获取字典（含已删除）
            this.http.get('web/config/dictItem/getDictJson').then(res => {
              this.store.commit('SET_DICTJSON_ALL', res.data);
            });

            this.lastDicTime = new Date().getTime();
          }
        });
      }, 30000);
    },

    getBaseData() {
      //不管怎么样，都要创建一个登录路由
      this.$router.addRoute({
        path: '/login',
        component: resolve => {
          require([`./pages/other/account/login.vue`], resolve);
        },
        meta: {
          keep_alive: true,
          name: this.$t('denglu')
        }
      });

      this.$router.addRoute({
        path: '/utils/preview',
        component: resolve => {
          require([`./pages/other/utils/preview.vue`], resolve);
        },
        meta: {
          keep_alive: false,
          name: this.$t('yulan')
        }
      });

      //获取国际化
      const lang = localStorage.getItem('lang');
      let langParam = '1';
      if (lang === 'en_US') {
        langParam = '2';
      } else if (lang === 'de_DE') {
        langParam = '3';
      } else if (lang === 'ru_RU') {
        langParam = '4';
      } else if (lang === 'vi_VN') {
        langParam = '5';
      }
      this.http.get('web/config/i18n/getByLanguages?lang=' + langParam).then(res => {
        // 根据当前语言设置ElementUI的语言包
        res.data.el = getElementUILocale(lang).el;
        this.i18n.mergeLocaleMessage(lang, res.data);
      });

      if (!this.utils.isUserLogin()) {
        if (this.$route.path != '/login') {
          this.$router.push('/login');
        }
        return;
      }

      let routes = [];
      Promise.all([
        //获取字典
        this.http.get('web/config/dictItem/getDictJson?deleted=false').then(res => {
          this.store.commit('SET_DICTJSON', res.data);
        }),
        //获取字典（含已删除）
        this.http.get('web/config/dictItem/getDictJson').then(res => {
          this.store.commit('SET_DICTJSON_ALL', res.data);
        }),

        //获取客制化配置字段，要登陆
        this.http.get('web/config/custom/table/fields/list').then(res => {
          this.store.commit('SET_CUSTOMER_TABLE_FIELDS', res.data);
        }),

        //获取用户菜单，要登陆
        this.http.get('web/system/auth/menu/treeUser').then(res => {
          this.store.commit('SET_MENUS', res.data);
        }),
        //获取用户信息，要登陆
        this.http.get('web/system/auth/user/info').then(res => {
          this.store.commit('SET_USER', res.data);
        }),
        //获取客户信息，要登陆
        this.http.get('web/customer/info').then(res => {
          this.store.commit('SET_CUSTOMER', res.data);
        }),

        //获取权限，要登陆
        this.http.get('web/system/auth/menu/getMenuCodeByPlatform?platform=2').then(res => {
          this.store.commit('SET_ACTIONS', res.data);
        }),

        //获取用户菜单，要登陆
        // this.http.get('web/system/auth/menu/treeUser', {
        // 	params: {
        // 		platform: 1
        // 	}
        // }).then(res => {
        // 	console.log(res)
        // 	this.store.commit('SET_MENUS', res.data);
        // }),

        //获取设备配置点信息列表
        // this.http.get('web/equipment/getEquipmentPoint').then(res => {

        // 	this.store.commit('SET_EQ_POINTS', res.data);
        // }),

        //获取客户列表
        this.http
          .get('web/customer/page', {
            params: {
              pageNum: 1,
              pageSize: 1000
            }
          })
          .then(res => {
            this.store.commit('SET_CUSTOMERS', res.data.rows);
          }),
        //获取客户角色列表
        this.http
          .get('/web/customer/auth/role/list', {
            params: {}
          })
          .then(res => {
            this.store.commit('SET_CUSTOMER_ROLES', res.data);
          }),
        //获取组织结构
        this.http.get('web/setting/org/tree').then(res => {
          this.store.commit('SET_ORGANIZATIONS', res.data);
          console.log(res.data);
        }),
        //获取组织结构(不带一级)
        this.http.get('web/setting/org/subTreeOrg').then(res => {
          this.store.commit('SET_SUB_ORGANIZATIONS', res.data);
        }),

        //获取用户路由
        this.http.get('web/system/auth/menu/list?platform=1&type=1').then(res => {
          //写入路由
          for (var i = 0; i < res.data.length; i++) {
            let component = res.data[i].component;
            let code = res.data[i].code;
            let route = res.data[i].route;
            let componentName = res.data[i].componentName;
            if (!(route && route != '')) {
              continue;
            }
            if (componentName == '') {
              console.log('缺少compnentName:', route);
            }
            routes.push({
              path: route,
              component: resolve => {
                // require([`./pages`+`/global/menu/list.vue`], resolve)
                require([`./pages${component}.vue`], resolve);
              },
              meta: {
                keep_alive: true,
                name: this.$t(code),
                componentName: componentName,
                link: res.data[i].route
              }
            });
          }
        }),
        //获取用户路由
        this.http.get('web/system/auth/menu/list?platform=2&type=1').then(res => {
          let N = 0;
          //写入路由
          for (var i = 0; i < res.data.length; i++) {
            let component = res.data[i].component;
            let code = res.data[i].code;
            let route = res.data[i].route;
            let componentName = res.data[i].componentName;
            if (!(route && route != '')) {
              continue;
            }
            if (componentName == '') {
              console.log('缺少compnentName:', route);
            }
            if (code == 'web_fanbi_admin') {
              console.log(res.data[i]);
            }
            //单独针对报表的操作一下
            if (componentName == 'web_common_biframe') {
              component = component + '/' + 'index';
              componentName = componentName + '_index';
              route = route.split('?')[0];
              N++;
            }

            // if (componentName == 'web_common_biframe') {
            //   component = component + '/' + N;
            //   componentName = componentName + '_' + N;
            //   route = route.split('?')[0];
            //   N++;
            // }

            routes.push({
              path: route,
              component: resolve => {
                // require([`./pages`+`/global/menu/list.vue`], resolve)
                require([`./pages${component}.vue`], resolve);
              },
              meta: {
                keep_alive: true,
                name: this.$t(code),
                componentName: componentName,
                link: res.data[i].route,
                code: code
              }
            });
          }
        })
      ])
        .then(() => {
          //获取异常，运维以外的账号才获取
          // (this.store.state.user.type != 0 && this.store.state.user.type != 1) && this.http.get(
          // 	'web/basic/defectType/getDefectTypeTree').then(res => {
          // 	this.store.commit('SET_DEFECT_TYPES', res.data);
          // }),

          //获取仓库仓位,wms账号才 获取
          // (this.store.state.customer.type == 4) && this.http
          // 	.get(
          // 		'web/basic/warehouse/getWarehouseAreaLocation').then(res => {
          // 		this.store.commit('SET_WAREHOUSE', res.data);
          // 	}),

          //获取PCDS
          //循环转换c里面的key
          this.http.get('web/chinaRegion/tree').then(res => {
            function changeRegionKey(item) {
              item.id = item.ac;
              item.label = item.n;
              item.children = item.c;
              if (item.children) {
                if (item.children.length > 0) {
                  item.children = item.children.map(item2 => {
                    return changeRegionKey(item2);
                  });
                } else {
                  delete item.children;
                }
              }
              return item;
            }
            const pcds = res.data.map(item => {
              return changeRegionKey(item);
            });
            this.store.commit('SET_PCDS', pcds);
          });
          //获取wms客户信息
          this.http.get('web/wms/customer/page?pageNum=1&pageSize=9999').then(res => {
            this.store.commit('SET_WMS_CUSTOMER', res.data.rows);
          });

          //获取设备列表
          this.store.state.user.type != 0 &&
            this.store.state.user.type != 1 &&
            this.http.get('web/equipment/getEquipmentList').then(res => {
              this.store.commit('SET_EQS', res.data);
              let reqs = [];
              let equipmentIdList = [];
              for (var i = 0; i < res.data.length; i++) {
                let eq = res.data[i];
                equipmentIdList.push(eq.id);

                if (equipmentIdList.length === 50 || i === res.data.length - 1) {
                  let params = {
                    equipmentIdList: equipmentIdList
                  };
                  let req = this.http.get('web/equipment/getEquipmentPoint', {
                    params: params
                  });
                  reqs.push(req);
                  // 清空 equipmentIdList，准备下一组的请求
                  equipmentIdList = [];
                }
              }
              return Promise.all(reqs)
                .then(points => {
                  let eqsPoint = {};
                  for (var i = 0; i < points.length; i++) {
                    Object.assign(eqsPoint, points[i].data);
                  }
                  this.store.commit('SET_EQ_POINTS', eqsPoint);
                })
                .catch(err => {
                  console.log(err);
                });
            });
          console.log(routes);
          this.$router.addRoute({
            name: 'index',
            path: '/',
            component: function(resolve) {
              require(['@@/pages/index/index'], resolve);
            },
            meta: {
              keep_alive: false, //这里前往不要true，否则有两个vue实例
              require_login: false,
              name: this.$t('shouye')
            },
            children: routes
          });

          //生成完菜单后，直接跳转到路径
          if (this.$route.path == '/') {
            if (this.store.state.user.type) {
              this.store.state.router_tabs = [];
              if (store.state.customer.type == 1 || store.state.customer.type == 3) {
                this.$router.push('/web/home');
              } else if (store.state.customer.type == 2 || store.state.customer.type == 6 || store.state.customer.type == 7 || store.state.customer.type == 8) {
                this.$router.push('/web/home_mes');
              } else if (store.state.customer.type == 4) {
                this.$router.push('/web/home_wms');
              }
            } else {
              this.$router.push('/admin/customer/info');
            }
            // this.$router.push('/web/index');
            //this.$router.push('/web/system/user/list');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    toLogin(params) {
      localStorage.removeItem('ssoToken');
      localStorage.removeItem('token');
      if (this.$route.path == '/utils/preview') {
        return;
      }
      window.location.reload();
    }
  }
});
